__turbopack_context__.v({
  "ivBodyText": "DhuHpG_ivBodyText",
  "ivContentShell": "DhuHpG_ivContentShell",
  "ivSectionHeading": "DhuHpG_ivSectionHeading",
  "ivSectionLabel": "DhuHpG_ivSectionLabel",
  "ivSectionRootDark": "DhuHpG_ivSectionRootDark",
  "ivSectionRootWhite": "DhuHpG_ivSectionRootWhite",
});
